import React from "react";
import PropTypes from "prop-types";
// import "./SelectArrayIcons-style.scss"

const SelectArrayIcons = (props) => {

  const {
    label = '',
    name = '',
    value = '',
    className = '',
    data = [],
    hasError = false,
    onChange = () => {},
    error = '',
    isLoading,
  } = props

  const handleClick = (newValue) => {
    if (isLoading || newValue === value) return;
    onChange({ target: { name, value: newValue } });
  };

  return (
    <div className={className + 'select-icons '}>
      <label>
        {label}
        {hasError && <span className="error"> - {error}</span>}
      </label>
      <div className="items">
        {data.map((item, index) => (
          <div
            className={`item ${item.value === value ? 'active' : ''}`}
            onClick={() => handleClick(item.value)}
            key={index}
          >
            <img src={item.icon} alt=""/>
            <span className="icon-label">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

SelectArrayIcons.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.array,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.string,
}

export default SelectArrayIcons
